import script from "./AppInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppInfo.vue?vue&type=script&lang=ts&setup=true"

import "./AppInfo.vue?vue&type=style&index=0&id=a959dc62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a959dc62"]])

export default __exports__